export type TrustlyBaseEstablishData = {
    accessId: string;
    merchantId: string;
    currency: string;
    amount: string;
    displayAmount: string;
    merchantReference: string;
    paymentType: string;
    returnUrl: string;
    cancelUrl: string;
    notificationUrl: string;
    requestSignature?: string;
};

export type TrustlyMetadata = {
    flowType?: string;
    finishButtonLabelType?: string;
    integrationContext?: 'InAppBrowser' | 'InAppBrowserNotify';
    urlScheme?: string;
};

export type TrustlyEstablishData = {
    description: string;
    kycType: number;
    customer: TrustlyEstablishDataCustomer;
    metadata?: TrustlyMetadata;
    paymentProviderId?: string;
} & TrustlyBaseEstablishData;

export type TrustlyRefreshSplitTokenEstablishData = TrustlyBaseEstablishData & {
    authToken: string;
    transactionId: string;
    metadata?: TrustlyMetadata;
};

type TrustlyAddress = {
    address1: string;
    city: string;
    state: string;
    zip: string;
    country: string;
};

type TrustlyEstablishDataCustomer = {
    externalId: string;
    taxId: string;
    name: string;
    phone: string;
    email: string;
    address: TrustlyAddress;
    enrollDate: number; // Unix timestamp in ms
    dateOfBirth: string; // YYYY-MM-DD / YYYY-M-D
};

export type TrustlyMessage = {
    nativeEvent: {
        data: string;
        url: string;
    };
};

export enum TrustlyStatus {
    TRANSACTION = 'trustly_transaction',
    CANCEL = 'trustly_cancel',
    REFRESH = 'trustly_refresh',
    REFRESH_CANCEL = 'trustly_refresh_cancel',
}
